import { getSvgIconUrl } from '@helpers/iconURLs';
import React from 'react';
import { ExploreTheForumCardStyles as S } from './ExploreTheForumCard.styles';
const ExploreTheForumCard = (props) => {
    return (React.createElement(S.Container, { href: props.cta.url, target: props.cta.target ?? '_self', title: props.title, "data-index": props.index },
        props.icon && (React.createElement(S.IconBlock, null,
            React.createElement(S.IconWrapper, { "$svgUrl": getSvgIconUrl(props.icon) }))),
        React.createElement(S.Title, null, props.title),
        React.createElement(S.Description, { dangerouslySetInnerHTML: { __html: props.description } }),
        React.createElement(S.Cta, { buttonType: "text-only" }, props.cta.text)));
};
export default ExploreTheForumCard;
